import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import des traductions
import fr from './locales/fr.json';
import en from './locales/en.json';

const resources = {
  fr: {
    translation: fr
  },
  en: {
    translation: en
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: 'fr', // Langue par défaut
    fallbackLng: 'fr',
    
    // Configuration du détecteur de langue
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
    
    // Configuration de l'interpolation
    interpolation: {
      escapeValue: false, // React échappe déjà les valeurs
    },
    
    // Configuration des namespaces
    defaultNS: 'translation',
    ns: ['translation'],
    
    debug: false,
    showSupportNotice: false,
    
    // Configuration des pluriels
    pluralSeparator: '_',
    contextSeparator: '_',
  });

export default i18n;
